import { DataTable, MainButton, PageWrapper, STATUSPAGE } from '@repo/ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'reactstrap';

import { makeColumnsEntities } from '../common/columns/columns-entities';
import { useEntities } from '../hooks/useEntities';

export const EntityList = () => {
  // Hooks
  const navigate = useNavigate();
  const { requestEntitiesList, entitiesListData, listStatus } = useEntities();

  // Effects
  useEffect(() => {
    requestEntitiesList();
  }, []);

  return (
    <PageWrapper title="Organização">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Organizações</h4>
          <p className="text-muted mb-0">
            Cadastre aqui as organizações que utilizarão o Rade App e outros
            serviços do Rade.
          </p>
        </div>

        <MainButton
          onClick={() => {
            navigate('/organizacoes/novo');
          }}
        >
          <i className="ri-add-line" style={{ fontSize: '1rem' }}></i>Nova
          Organização
        </MainButton>
      </div>

      <Card className="p-3">
        <DataTable
          noDataTitle="Nenhuma organização encontrada"
          noDataDescription="Não há organizações cadastradas no momento."
          actions={[
            {
              id: 2,
              name: 'Editar',
              label: 'Editar',
              onPress: (entities) => {
                navigate(`/organizacao/${entities.id}?painel=dados-cadastrais`);
              },
              nameFeatherIcon: 'edit',
              classNameColorIcon: 'primary',
            },
          ]}
          data={entitiesListData || []}
          loading={listStatus === STATUSPAGE.LOADING}
          canSearch={true}
          columns={makeColumnsEntities()}
          defaultSortAsc={true}
          defaultSortFieldId={1}
          keysSearch={['name']}
        />
      </Card>
    </PageWrapper>
  );
};
